<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="模式">
        <el-select v-model="form.mode" :clearable="true" placeholder="请选择模式">
          <el-option label="自由模式" value="free" />
          <el-option label="练习模式" value="story" />
        </el-select>
      </el-form-item>
      <el-form-item label="故事" class="story">
        <el-select v-model="form.story" :clearable="true" placeholder="请选择故事">
          <el-option v-for="story in stories" :key="story.code" :label="story.desc" :value="story.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="form.role" :clearable="true" placeholder="请选择角色">
          <el-option v-for="role in roles" :key="role.code" :label="role.desc" :value="role.code" />
        </el-select>
      </el-form-item>
      <div class="align-right">
        <el-button @click="fetchData">查询</el-button>
        <!-- <el-button @click="addCustomer">新增</el-button> -->
      </div>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="48"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
    >
      <el-table-column align="center" label="模式" min-width="95">
        <template slot-scope="scope">
          {{ scope.row.modeDesc }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="storyName" sortable label="故事名称" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.storyName }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="role" sortable label="角色" min-width="120">
        <template slot-scope="scope">
          {{ scope.row.role }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="更新时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.lastUpdated }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="130">
        <template slot-scope="scope">
          <!-- <el-button @click="delItem(scope)">删除</el-button> -->
          <el-button @click="editItem(scope)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getExerciseList, roleOptions, storyOptions } from '@/api/exercise'
import dayjs from 'dayjs'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      listLoading: false,
      stories: [],
      roles: [],
      form: {
        mode: '',
        role: '',
        story: ''
      }
    }
  },
  created() {
    this.fetchData()
    this.fetchRoles()
    this.fetchStories()
  },
  methods: {
    fetchData() {
      this.listLoading = true
      const params = {
        mode: this.form.mode,
        storyId: this.form.story,
        roleType: this.form.role
      }
      getExerciseList(params).then(response => {
        response.data.forEach(res => {
          res.lastUpdated = dayjs(res.lastUpdated).format('YYYY-MM-DD HH:mm:ss')
          res.modeDesc = res.mode === 'free' ? '自由模式' : '练习模式'
        })
        console.log('res-----', response.data)
        this.list = response.data
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    fetchRoles() {
      roleOptions().then(res => {
        this.roles = res.data
        console.log('roles---', res)
      })
    },
    fetchStories() {
      storyOptions().then(res => {
        this.stories = res.data
        console.log('stories---', res)
      })
    },
    editItem(val) {
      console.log('editItem', val)
      this.$router.push({ name: 'updateExercise', params: val.row })
    },
    delItem(val) {
      console.log('delItem', val)
    },
    addCustomer() {
      this.$router.push({ name: 'AddCustomer' })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-table{
    overflow: auto;
  }
  .el-form{
    position: relative;
    display: flex;
  }
  .el-form-item__content{
    display: flex;
    position: relative;
  }
  .el-button {
    margin-left: 10px;
  }
  .story{
    .el-input__inner {
      width: 350px;
    }
  }
}
.align-right {
  position: absolute;
  right: 0;
  top: 0;
}
</style>

